import { array, object, string, number } from "yup";

const LocationSchema = object({
  name: string().min(3).required(),
  owner: string().nullable().optional(),
  address: string().nullable().optional(),
  city: string().min(3).required(),
  state: string().required(),
  zipCode: string().min(5).required(),
  country: string().min(2).required(),
  coordinates: array(number()).length(2),
  uom: string().required(),
});

export default LocationSchema;
